import config from "@/config";
import { getJwt, setJwt } from "../auth/utils";

export const DEFAULT_STALE_TIME = 1 * 60 * 1000;

export const fetchServer = async (
  url: string,
  options: Omit<RequestInit, "body"> & {
    body?: string | unknown;
    reloadOn401?: boolean;
    mainRoot?: boolean;
  } = {
    reloadOn401: true
  }
): Promise<Response> => {
  const { token } = getJwt();
  if (!options.method && options.body) {
    options.method = "POST";
  }

  let mainRoot = config.APP_ROOT_API;
  if (!options.mainRoot) {
    mainRoot = config.APP_ROOT_API + "/olkypass";
  }

  // Automatically include the token and set the content type
  options.headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers
  };

  let optionBody: string | null = null;
  if (options.body) {
    if (typeof options.body !== "string") {
      try {
        optionBody = JSON.stringify(options.body);
      } catch (e) {
        console.error(e);
      }
    } else {
      optionBody = options.body;
    }
  }
  const data = await fetch(mainRoot.replace(/\/$/, "") + "/" + url.replace(/^\//, ""), {
    ...options,
    body: optionBody
  });

  if (data.status === 401 && options.reloadOn401 !== false) {
    setJwt({ token: null });
    document.location.reload();
  }

  return data;
};
